import { render, staticRenderFns } from "./LiveMonitoring.vue?vue&type=template&id=45b823fe&scoped=true"
import script from "./LiveMonitoring.vue?vue&type=script&lang=js"
export * from "./LiveMonitoring.vue?vue&type=script&lang=js"
import style0 from "./LiveMonitoring.vue?vue&type=style&index=0&id=45b823fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b823fe",
  null
  
)

export default component.exports